<section
  class="product-catalogs"
  id="catalogsAndDocs"
  [class.product-catalogs--stacked]="stackedBelowSpecs()">
  <div class="product-catalogs__header">
    <div class="product-catalogs__title-container">
      <h3 class="product-catalogs__title">
        {{ 'products.catalogsAndDesignSheets' | translate }}
      </h3>
      <p class="product-catalogs__subtitle">
        {{ 'products.catalogsDesignSheetsSubtitle' | translate }}
      </p>
    </div>

  </div>

  @if (pdfFiles().length) {
    <div class="product-catalogs__pdf-row">
      @for (pdf of pdfFiles(); track pdf._id) {
        <a
          class="product-catalogs__pdf-card"
          [href]="catalogHref(pdf)"
          target="_blank"
          rel="noopener noreferrer">
          <span class="product-catalogs__pdf-icon" aria-hidden="true">
            <img
              ngSrc="assets/icons/pdf-icon.png"
              width="22"
              height="22"
              alt="" />
          </span>
          <span class="product-catalogs__pdf-info">
            <span class="product-catalogs__pdf-name">{{
              catalogDisplayName(pdf)
            }}</span>
            <span class="product-catalogs__pdf-meta">{{
              catalogMetaLabel(pdf)
            }}</span>
          </span>
          <span class="product-catalogs__pdf-download" aria-hidden="true">
            <i class="iconsax" icon-name="download-1"></i>
          </span>
        </a>
      }
    </div>
  }

  @if (imageFiles().length) {
    <div class="product-catalogs__media-grid">
      @for (image of imageFiles(); track image._id; let i = $index) {
        <article
          class="product-catalogs__media-card"
          [class.product-catalogs__media-card--slate]="
            !catalogImageSrc(image) && gridCardVariant(i) === 'slate'
          "
          [class.product-catalogs__media-card--accent]="
            !catalogImageSrc(image) && gridCardVariant(i) === 'accent'
          "
          [class.product-catalogs__media-card--dark]="
            !catalogImageSrc(image) && gridCardVariant(i) === 'dark'
          "
          [class.product-catalogs__media-card--has-image]="!!catalogImageSrc(image)"
          [class.product-catalogs__media-card--interactive]="
            !!catalogImageSrc(image)
          "
          (click)="catalogImageSrc(image) && openImagePreview(image, $event)"
          (keydown.enter)="
            catalogImageSrc(image) && openImagePreview(image, $event)
          "
          [attr.tabindex]="catalogImageSrc(image) ? 0 : null"
          [attr.role]="catalogImageSrc(image) ? 'button' : null">
          @if (catalogImageSrc(image)) {
            <img
              class="product-catalogs__media-image"
              [src]="catalogImageSrc(image)"
              [alt]="catalogDisplayName(image)" />
          }
          <p class="product-catalogs__media-label">
            {{ catalogDisplayName(image) }}
          </p>
        </article>
      }
    </div>
  }
</section>
